<template>
    <div>
        <Menu v-bind="this.$attrs" @openMenu="push" @closeMenu="pull" disableEsc="true">
            <slot></slot>
        </Menu>
    </div>
</template>

<script>
import Menu from '@/components/Menu/BaseMenu'
export default {
  name: 'push',
  components: {
    Menu: Menu
  },
  methods: {
    openMenu () {
      this.$emit('openMenu')
    },
    closeMenu () {
      this.$emit('closeMenu')
    },
    push () {
      document.body.style.overflowX = 'hidden'
      let pageWidth = document.querySelector('#page-wrap').clientWidth
      if (document.body.clientWidth < 992) {
        document.querySelector('#page-wrap').style.width = `${pageWidth}px`
      }
      if (this.$attrs.right) {
        document.querySelector('#page-wrap').style.marginLeft = '-18rem'
      } else {
        document.querySelector('#page-wrap').style.marginLeft = '18rem'
        document.querySelector('#page-wrap').classList.add('fit-page')
        document.querySelector('.header-container input').classList.remove('ml-24')
        document.querySelector('#header-search-results').classList.remove('sm:ml-24')
      }

      document.querySelector('#page-wrap').style.transition =
        'all 0.5s ease 0s'
    },
    pull () {
      document.querySelector('#page-wrap').style.transition =
        'all 0.5s ease 0s'
      document.querySelector('#page-wrap').style.width = '100%'
      document.querySelector('#page-wrap').style.marginLeft = '0px'
      document.querySelector('#page-wrap').classList.remove('fit-page')
      document.querySelector('#page-wrap').style.transform = ''
      document.querySelector('.header-container input').classList.add('ml-24')
      document.querySelector('#header-search-results').classList.add('sm:ml-24')
      document.body.removeAttribute('style')
    }
  }
}
</script>
